import { libApiInstance } from '../axios';
import { ContactsSegmentsResponse } from './types/ContactsSegmentsResponse';

export async function requestSegments(signal?: AbortSignal): Promise<ContactsSegmentsResponse[]> {
    const result = await libApiInstance.get('/contacts/segments', { signal });

    return result.data;
}
